module.exports = __webpack_public_path__ + "5cd09b1a709d1d55aaa1ef711ada01d0.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@webapp/preact-shared/img/icon-alert-yellow@3x.png
// module id = 278
// module chunks = 7